/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { useSelector } from 'react-redux';
import { useParams, useHistory, useLocation } from 'react-router-dom';

import { globals as globalsSlice } from '../../app/globalsSlice';
import { userCan } from '../../common/utils/service';
import PageTitle from '../../components/PageTitle';
import { t } from '../../providers';
import { me as meSlice } from '../AuthenticatedPage/authenticationSlice';
import FieldsMissingDialog from '../MyAccountPage/components/ChildAccounts/FieldsMissingDialog';
import ServicesList from './components/ServicesList/ServicesList';
import servicesItems from './servicesItems';

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        height: '100%',
        maxWidth: 'calc(100% - 236px)',
        '@media (max-width:1100px)': {
            minWidth: '77%',
            maxWidth: 'unset',
        },
    },
    tabs: {
        '& .MuiTab-root': {
            minWidth: '100px',
        },
    },
    tabContainer: {
        width: '100%',
    },
    profileTabContainer: {},
}));

const TRADEMARKS = 'trademark';
const DESIGNS = 'design';

const OnlineServicesPage = () => {
    const classes = useStyles();
    const { service } = useParams();
    const location = useLocation();
    const history = useHistory();
    const me = useSelector(meSlice);
    const { globals } = useSelector(globalsSlice) || {};
    const readOnly = !!(me || {}).impersonatedUser;

    const [tabs, setTabs] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);

    const tabIndex = !!~tabs.indexOf(service) ? tabs.indexOf(service) : 0;

    useEffect(() => {
        const { authorities } = me;
        const allowedTabs = [];

        if (userCan(authorities, 'ROLE_TRADEMARKS')) allowedTabs.push(TRADEMARKS);
        if (userCan(authorities, 'ROLE_DESIGNS')) allowedTabs.push(DESIGNS);

        setTabs(allowedTabs); //set tabs depending on tabs allowed based on authorities role

        if (allowedTabs.length > 0) {
            if (!service || service === 'undefined') history.push(`/online-services/${allowedTabs[0]}`);
        } else {
            history.push('/');
        }
    }, [service, me, history]);

    const handleTabChange = (event, value) => {
        event.preventDefault();
        history.push(`/online-services/${tabs[value]}`);
    };

    const navigateTo = (event, path, external, requiredProfileDetails = false) => {
        event.preventDefault();
        if (path && external) {
            if (!readOnly) {
                let isComplete = true;
                if (requiredProfileDetails) isComplete = !!me && me.accountProfileCompleted;
                if (!isComplete) {
                    setDialogOpen(true);
                } else {
                    //get path form globals
                    let newPath = globals.ipo[path];
                    if (!!newPath && !newPath.startsWith('http')) newPath = globals.ipo['fo.url'].concat(globals.ipo[path]);
                    if (!!newPath) window.open(newPath, '_blank');
                }
            }
        } else {
            if (path && location.pathname !== path) {
                history.push(path);
            }
        }
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDialogOpen(false);
        history.push('/my-account/profile-details');
    };

    const cancelMessage = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    return (
        <div className={classes.container}>
            <PageTitle title={t('online.services.title')} details={t('online.services.description')} />
            <Tabs className={classes.tabs} value={tabIndex} onChange={handleTabChange} textColor="primary">
                {tabs.map((tab, index) => (
                    <Tab id={`tab-${tab}-${index}`} key={'tab-' + index} label={t(tab + '.tab.title')} />
                ))}
            </Tabs>
            {globals ? (
                <div className={classes.profileTabContainer}>
                    {service && <ServicesList readOnly={readOnly} items={servicesItems[service]['services']} navigateTo={navigateTo} />}
                </div>
            ) : (
                <CircularProgress />
            )}
            <FieldsMissingDialog open={dialogOpen} onAccept={navigateToProfile} onCancel={cancelMessage} />
        </div>
    );
};

export default OnlineServicesPage;
